import { useState, useEffect } from "react";
import { 
    useDisplayOrderSettingsQuery, 
    useOrderSettingsAddMutation, 
    useUpdateOrderSEttingsMutation 
} from "../../Services/OrdersAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

function AddCategory() {
    // Fetch order settings
    const { data, refetch } = useDisplayOrderSettingsQuery();
    const [shippingId, setShippingId] = useState("");
    const [extraFields, setExtraFields] = useState({
        type: "free",
        amount: "",
    });

    useEffect(() => {
        if (data?.data?.length) {
            // Find the active shipping rate with status: 1
            const activeShippingRate = data.data.find(item => item.status === 1);

            if (activeShippingRate) {
                setExtraFields({
                    type: activeShippingRate.type || "free",
                    amount: activeShippingRate.amount || "",
                });
                setShippingId(activeShippingRate.id);
            }
        }
    }, [data]);

    console.log("Order Settings Data:", data);

    const [apiError, setApiError] = useState(null);
    const [AddOrderSettings, { isLoading }] = useOrderSettingsAddMutation();
    const [UpdatedOrderSettings, { isLoading: UpdateLoading }] = useUpdateOrderSEttingsMutation();

    // Handle radio button change
    const handleTypeChange = (e) => {
        const { value } = e.target;
        setExtraFields((prevState) => ({
            ...prevState,
            type: value,
            amount: value === "fixed" ? prevState.amount : "",
        }));
    };

    // Handle input field change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setExtraFields((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Construct JSON payload
        const payload = {
            type: extraFields.type,
            status: 1, // Always send status as 1
        };

        // Add amount only if type is "fixed"
        if (extraFields.type === "fixed") {
            payload.amount = extraFields.amount;
        }

        try {
            if (shippingId) {
                // If shippingId exists, update the settings
                await UpdatedOrderSettings({ id: shippingId, formData: payload }).unwrap();
                alert("Settings updated successfully!");
            } else {
                // If shippingId doesn't exist, add new settings
                await AddOrderSettings(payload).unwrap();
                alert("Settings added successfully!");
            }

            refetch(); // Refresh data
            setApiError(null);
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    return (
        <div>
            <h3>
                Shipping Rate
                <div className="tooltip-container">
                    <FontAwesomeIcon
                        icon={faCircleInfo}
                        className="text-warning mx-2"
                        style={{ cursor: "pointer" }}
                    />
                    <div className="tooltip">Choose either Fixed Rate or Free.</div>
                </div>
            </h3>

            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        <div className="col-md-6 col-sm-6">
                            <div className="mb-3">
                                {/* Radio Buttons */}
                                <div className="mb-2">
                                    <input
                                        type="radio"
                                        id="free"
                                        name="type"
                                        value="free"
                                        className="form-check-input"
                                        checked={extraFields.type === "free"}
                                        onChange={handleTypeChange}
                                    />
                                    <label htmlFor="free" className="form-check-label ms-2">
                                        Free
                                    </label>
                                </div>

                                <div>
                                    <input
                                        type="radio"
                                        id="fixed"
                                        name="type"
                                        value="fixed"
                                        className="form-check-input"
                                        checked={extraFields.type === "fixed"}
                                        onChange={handleTypeChange}
                                    />
                                    <label htmlFor="fixed" className="form-check-label ms-2">
                                        Fixed Rate
                                    </label>
                                </div>

                                {/* Conditionally Show Amount Input */}
                                {extraFields.type === "fixed" && (
                                    <div className="mt-2">
                                        <label htmlFor="amount" className="form-label">Enter Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            name="amount"
                                            className="form-control"
                                            value={extraFields.amount}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* API Error Message */}
                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    {/* Submit Button */}
                    <button type="submit" className="btn btn-primary" disabled={isLoading || UpdateLoading}>
                        {isLoading || UpdateLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
